export function waitFor(fn: Function) {
  return new Promise((resolve, reject) => {
    let counter = 0;
    const interval = setInterval(validate, 500);

    validate();

    function validate() {
      if (counter >= 100) {
        clearInterval(interval);
        return reject();
      }

      const result = fn();

      if (result) {
        clearInterval(interval);
        return resolve(result);
      }
      counter += 1;
    }
  });
}

export function isAsync(fn: Function): Boolean {
  return fn.constructor.name === 'AsyncFunction';
}

export function insertScript(url, id) {
  const promise = new Promise(async (resolve, reject) => {
    const fjs = document.getElementsByTagName('script')[0];

    if (document.getElementById(id)) {
      return resolve();
    }

    const scriptTag = document.createElement('script');
    scriptTag.id = id;
    scriptTag.src = url;


    scriptTag.addEventListener('load', () => resolve(), false);
    scriptTag.addEventListener('error', () => {
      scriptTag.remove();
      reject();
    }, false);

    fjs.parentNode.insertBefore(scriptTag, fjs);
  });

  return promise;
}
